import React from "react";
import { useNavigate } from "react-router-dom";

const ServiceCard = ({ title, subtitle, icon: Icon, delay, isFancy, serviceId }) => {
  const navigate = useNavigate();
  
  const baseClass = isFancy
    ? "relative p-6 rounded-3xl bg-white/30 backdrop-blur-lg border border-emerald-200 shadow-md hover:shadow-xl transition-all duration-500 transform hover:-translate-y-3 hover:scale-105 cursor-pointer"
    : "p-6 rounded-xl bg-white shadow-md border border-gray-200 hover:shadow-lg transition cursor-pointer";

  const handleClick = () => {
    navigate("/services");
    setTimeout(() => {
      const element = document.getElementById(`service-${serviceId}`);
      if (element) {
        const navbarHeight = 160; // Increased offset to ensure heading is clearly visible
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }, 100);
  };

  return (
    <div 
      data-aos={isFancy ? "fade-up" : ""} 
      data-aos-delay={delay} 
      className={baseClass}
      onClick={handleClick}
    >
      <div className={`flex items-center justify-center w-14 h-14 rounded-xl text-[#00CD97] mb-5 ${isFancy ? "bg-white/10 shadow-lg" : ""}`}>
        <Icon className="w-7 h-7" />
      </div>
      <h3 className="text-lg font-bold text-gray-900 mb-1">{title}</h3>
      <p className="text-gray-600 text-sm">{subtitle}</p>
    </div>
  );
};

export default ServiceCard;
